import he from 'he';
import DOMPurify from 'dompurify';
import { useEffect, useRef } from 'react';

interface HtmlRendererProps {
  htmlString: string | null;
}

export default function HtmlRenderer({ htmlString }: HtmlRendererProps) {


  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (divRef.current) {
      const links = divRef.current.querySelectorAll('a');
      links.forEach((link) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });
    }
  }, [htmlString]);

  if(!htmlString) return null;

  const decodedHtml = he.decode(htmlString);
  const clean = DOMPurify.sanitize(decodedHtml, {USE_PROFILES: {html: true}});


  return <div ref={divRef} dangerouslySetInnerHTML={{ __html: clean }} />;
}
